var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-breadcrumb',{staticClass:"m-0 p-0 text-light font-weight-light",staticStyle:{"background-color":"transparent !important"},attrs:{"items":_vm.breadcrumbs,"active-class":"text-light"}})}
var staticRenderFns = []

export { render, staticRenderFns }